export const enum LoginActionTypes {
  LOG_IN_REQUEST = '@@login/LOG_IN_REQUEST',
  LOG_IN_REQUEST_OKTA = '@@login/LOG_IN_REQUEST_OKTA',
  LOG_IN_SUCCESS = '@@login/LOG_IN_SUCCESS',
  MFA_FAIL = '@@login/MFA_FAIL',
  MFA_SUCCESS = '@@login/MFA_SUCCESS',
  LOG_IN_FAIL = '@@login/LOG_IN_FAIL',
  CONFIRM_NEW_PASSWORD_FAIL = '@@login/CONFIRM_NEW_PASSWORD_FAIL',
  CHANGE_PASSWORD = '@@login/CHANGE_PASSWORD',
  UPDATE_PASSWORD = '@@login/UPDATE_PASSWORD',
  UPDATE_PASSWORD_FAIL = '@@login/UPDATE_PASSWORD_FAIL',
  UPDATE_PASSWORD_SUCCESS = '@@login/UPDATE_PASSWORD_SUCCESS',
  LOG_TEST_API_REQUEST = '@@login/LOG_TEST_API_REQUEST',
  LOGOUT = '@@login/LOGOUT',
  MFA_AUTHENTICATE = '@@login/MFA_AUTHENTICATE',
  OKTA_TOKEN_REQUEST = '@@login/OKTA_TOKEN_REQUEST',
  OKTA_TOKEN_SUCCESS = '@@login/OKTA_TOKEN_SUCCESS',
  OKTA_TOKEN_FAILURE = '@@login/OKTA_TOKEN_FAILURE',
  SESSION_EXPIRED = 'SESSION_EXPIRED',
  OKTA_SESSION_STARTED = 'OKTA_SESSION_STARTED',
}

export interface LoginState {
  readonly userId: number;
  readonly username: string;
  readonly password: string;
  readonly parentPartyName: string;
  readonly parentPartyDibCode: string;
  readonly parentPartyId: number;
  readonly errorMessage: string;
  readonly showLoader: boolean;
  readonly mfaCode: string;
  readonly useMfa: boolean;
  readonly mfaQRCode: string;
  readonly registeredMfa: boolean;
  readonly accessToken: string;
}
